import { Navigate, createBrowserRouter } from "react-router-dom";
import Login from "./pages/Auth/login";
import App from "./App";
import Signup from "./pages/Auth/signup";
import Congratulations from "./pages/Auth/congrats";
import ForgotPassword from "./pages/Auth/forgotPassword";
import CheckEmail from "./pages/Auth/checkEmail";
import NewPassword from "./pages/Auth/newPassword";
import ResetSuccessful from "./pages/Auth/resetSuccessful";
import Payment from "./pages/SetupCost/payment";
import Thankyou from "./pages/Auth/thankyou";
import Invite from "./pages/SetupCost/invite";
import AddDeal from "./pages/SetupCost/addDeal";
import Otp from "./pages/Auth/otp";
import Services from "./pages/Main/settings/services";
import Settings from "./pages/Main/settings/index";
import Mainpage from "./pages/Main/mainpage";
import Personal from "./pages/Main/settings/personalsettings";
import Privacy from "./pages/Main/settings/privacy";
import Check from "./assets/icons/greenCheck.svg";
import ManageTeam from "./pages/Main/manageTeam";
import BusinessProfile from "./pages/Main/profile";
import InviteMember from "./components/common/inviteMember";
import Notifications from "./pages/Main/settings/notifications";
import InvitationSentCard from "./components/common/invitationSentCard";
import Delete from "./pages/Main/settings/delete";
import Terms from "./pages/Main/settings/terms";
import PrivacyPolicy from "./pages/Main/settings/privacypolicy";
import EditMember from "./pages/editMember";
import EditpaymentMethod from "./pages/editPaymentMethod";
import Protected from "./components/protected";
import Reviews from "./pages/reviews/Reviews";
import Samplenav from "./components/common/sampleNav";
import Order from "./pages/Main/order";
import OrderHistory from "./pages/Main/order/orderHistory";
import OrderReceipt from "./pages/Main/order/orderReceipt";
import Orders from "./pages/Main/order/orders";
import Message from "./pages/Main/messages";
import Messages from "./pages/Main/messages/message";
import Ads from "./pages/Main/ads";
import Support from "./pages/Main/support";
import NewAds from "./pages/Main/ads/newAds";
import CurrentAds from "./pages/Main/ads/currentAds";
import Appointment from "./pages/Main/messages/appointments";
import AppointmentSettings from "./pages/Main/messages/appointmentSettings";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Home from "./pages/Main/home";
import AdsCheckout from "./pages/Main/ads/checkout";
import PendingAds from "./pages/Main/ads/pendingads";
import Subservices from "./pages/Main/settings/subservices";
import TermsConditions from "./pages/termsAndConditions";
import Error from "./pages/Main/error/index";
import Benefits from "./components/common/benefits";
import OrderDetails from "./pages/Main/order/orderDetails";
import Location from "./pages/Main/location";
import PublicProfile from "./pages/Main/publicProfile";
import Messaging from "./pages/Main/settings/messaging";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLISH_KEY);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "signup",
    element: <Signup />,
  },

  {
    path: "congratulations",
    element: <Congratulations />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "checkemail",
    element: <CheckEmail />,
  },
  {
    path: "new-password",
    element: <NewPassword />,
  },
  {
    path: "new-password-for-invite",
    element: <NewPassword invite={true} />,
  },
  {
    path: "reset",
    element: <ResetSuccessful />,
  },
  {
    path: "payment",
    element: (
      <Protected>
        <Payment />
      </Protected>
    ),
  },
  {
    path: "sample",
    element: <Samplenav />,
  },
  {
    path: "thankyou",
    element: (
      <Thankyou
        heading="Thank You for Signing Up! We've Received Your Information & Your
    Account Is Under Review."
        paragraph="If Your Account Is Approved, You Will Receive an Email to Complete
        Your Registration Steps"
      />
    ),
  },
  {
    path: "thank-you-for-waiting",
    element: (
      <Thankyou
        heading="Your Account is Pending Approval from YupUp Admin."
        paragraph="Thank You For Waiting."
      />
    ),
  },
  {
    path: "invite",
    element: (
      <Protected>
        <Invite />
      </Protected>
    ),
  },
  {
    path: "deal",
    element: (
      <Protected>
        <AddDeal />
      </Protected>
    ),
  },
  {
    path: "otp",
    element: <Otp />,
  },

  {
    path: "main/*",
    element: (
      <Protected>
        <Mainpage />
      </Protected>
    ),
    children: [
      {
        path: "profile",
        element: <BusinessProfile />,
      },
      {
        path: "profile/manage-team",
        element: <ManageTeam />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "location",
        element: <Location />,
      },
      {
        path: "public-profile",
        element: <PublicProfile />,
      },
      {
        path: "settings/*",
        element: (
          <Protected>
            <Settings />
          </Protected>
        ),
        children: [
          {
            path: "",
            element: <Services />,
          },
          {
            path: "sub-services",
            element: <Subservices />,
          },
          {
            path: "personal/settings",
            element: <Personal />,
          },
          {
            path: "privacy",
            element: <Privacy />,
          },
          {
            path: "notifications",
            element: <Notifications />,
          },
          {
            path: "delete",
            element: <Delete />,
          },
          {
            path: "termsandconditions",
            element: <Terms />,
          },
          {
            path: "privacypolicy",
            element: <PrivacyPolicy />,
          },
          {
            path: "messaging",
            element: <Messaging />,
          },
        ],
      },
      {
        path: "profile/invite-sent",
        element: <InvitationSentCard />,
      },
      {
        path: "profile/edit-member",
        element: <EditMember />,
      },
      {
        path: "ads/checkout",
        element: (
          <Elements stripe={stripePromise}>
            <AdsCheckout />
          </Elements>
        ),
      },
      {
        path: "profile/invite-member",
        element: <InviteMember />,
      },
      {
        path: "profile/payment-method",

        element: (
          <Elements stripe={stripePromise}>
            <EditpaymentMethod />
          </Elements>
        ),
      },
      {
        path: "payment-complete",
        element: (
          <div className="p-3">
            <InvitationSentCard
              img={Check}
              text="Payment Complete"
              linkTo="/main/profile/payment-method"
            />
          </div>
        ),
      },
      {
        path: "profile/reviews",
        element: <Reviews />,
      },

      {
        path: "orders/*",
        element: (
          <Protected>
            <Order />
          </Protected>
        ),
        children: [
          { path: "", element: <Orders /> },
          { path: ":id", element: <OrderDetails /> },
          {
            path: "history",
            element: <OrderHistory />,
          },
          {
            path: "receipt",
            element: <OrderReceipt />,
          },
          {
            path: "appointments",
            element: <Appointment />,
          },
          {
            path: "appointment-settings",
            element: <AppointmentSettings />,
          },
        ],
      },
      {
        path: "message/*",
        element: (
          <Protected>
            <Home />
          </Protected>
        ),
        children: [{ path: "", element: <Home /> }],
      },
      {
        path: "ads/*",
        element: (
          <Protected>
            <Ads />
          </Protected>
        ),
        children: [
          { path: "", element: <NewAds /> },
          {
            path: "pending-ads",
            element: <PendingAds />,
          },
          {
            path: "current-ads",
            element: <CurrentAds />,
          },
        ],
      },
      {
        path: "support/*",
        element: (
          <Protected>
            <Support />
          </Protected>
        ),
      },
    ],
  },
  {
    path: "test",
    element: <Order />,
  },

  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/benefits",
    element: <Benefits />,
  },
  {
    path: "*",
    element: <Error />,
  },
]);

export default router;
